import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-instagram-auth-callback',
  templateUrl: './instagram-auth-callback.component.html',
  styleUrls: ['./instagram-auth-callback.component.css'],
})
export class InstagramAuthCallbackComponent implements OnInit {
  successMessage: string | null = null;
  errorMessage: string | null = null;
  returnUrl: string = '/root/social-connections';
  shouldUseFragment: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      const state = params['state'];

      if (code) {
        this.authService.exchangeInstagramCodeForToken(code, state).subscribe(
          (response) => {
            if (response.success) {
              this.successMessage =
                'You have successfully linked your Instagram account!';
              this.errorMessage = null;
              if (response.userDms || response.clientDms) {
                this.returnUrl = '/dashboard/settings';
                this.shouldUseFragment = true;
              }
            } else {
              this.successMessage = null;
              this.errorMessage =
                'Unfortunately, there was an error connecting your Instagram account.';
            }
          },
          (error) => {
            this.successMessage = null;
            this.errorMessage =
              'Unfortunately, there was an error connecting your Instagram account.';
            console.error('Error connecting Instagram:', error);
          }
        );
      }
    });

    setTimeout(() => {
      this.goBack();
    }, 10000);
  }

  goBack(): void {
    if (this.shouldUseFragment) {
      this.router.navigate([this.returnUrl], { fragment: 'profile' });
    } else {
      this.router.navigate([this.returnUrl]);
    }
  }
}
